import React from 'react'

function HorizontalSlider(props) {
	let value = props.value || 0
	let setValue = props.setValue || function() {}
	let scale = props.scale || 1
	let style = props.style || {}
	let color = props.color || 'white'
	return (
		<div style={style}>
			<div style={{position: 'relative', width: '100%'}}>
				<input
					type="range"
					min="0"
					max="1"
					step="0.0001"
					style={{width: '100%', height: '22px', position: 'absolute', left: '-2px', top: '-2px', opacity: 0, zIndex: 800}}
					onInput={function(event) {setValue(event.target.value*scale)}}
				/>
				<div style={{position: 'absolute', width: 'calc(100% - 20px)'}}>
					<div style={{position: 'absolute', left: (value/scale*100)+'%', width: '20px', height: '20px', background: color, borderRadius: '50%'}}></div>
				</div>
				<div style={{float: 'left', width: (value/scale*100)+'%', height: '6px', background: color, marginTop: '7px', borderRadius: '5px'}}></div>
				<div style={{float: 'left', width: ((1-value/scale)*100)+'%', height: '6px', background: color, marginTop: '7px', borderRadius: '5px'}}>
					<div style={{width: '100%', height: '100%', background: 'rgba(0, 0, 0, .7)', borderRadius: '5px'}}></div>
				</div>
				<div style={{clear: 'both'}}></div>
			</div>
		</div>
	)
}

export default HorizontalSlider
